import { Component, HostListener } from '@angular/core';

declare var window: any;

@Component({
  template: ''
})
export abstract class MaxLengthClass {
    @HostListener('keyup', ['$event']) onKeyup(event: any) {
        const element = event.target as HTMLInputElement;
        const limit = element.maxLength;
        var ua = window.navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf("android") > -1;

        if (isAndroid) {
            const value = element.value.substr(0, limit);
            if (value.length <= limit) {
                element.value = value;
            } else {
                element.value = value.substr(0, limit - 1);
            }
        }
    }

    @HostListener('focus', ['$event']) onFocus(event: any) {
        const element = event.target as HTMLInputElement;
        var ua = window.navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf("android") > -1;
        const limit = '"' + element.maxLength + '"';
        if (!isAndroid) {
            element.setAttribute('maxlength', limit);
        }
    }
}